import React from 'react';
import { Check, Utensils } from 'lucide-react';

const t = {
  en: {
    label: 'NUTRITION FOR STRENGTH ATHLETES',
    title: 'Eat for muscle. Not for diets.',
    items: [
      'High-protein recipes for optimal muscle building',
      'Calorie calculator and macro tracking for strength athletes',
      'Meal prep plans for the whole week',
    ],
  },
  de: {
    label: 'ERNÄHRUNG FÜR KRAFTATHLETEN',
    title: 'Iss für Muskeln. Nicht für Diäten.',
    items: [
      'Hochprotein-Rezepte für optimalen Muskelaufbau',
      'Kalorienrechner und Makro-Tracking für Kraftsportler',
      'Meal-Prep-Pläne für die ganze Woche',
    ],
  },
};

export default function NutritionSection({ lang }) {
  const tx = t[lang];

  return (
    <section className="py-24 px-6" style={{ backgroundColor: '#0f1117' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative order-2 md:order-1">
            <div
              className="rounded-2xl overflow-hidden"
              style={{ border: '1px solid rgba(59,130,246,0.15)' }}
            >
              <img
                src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80"
                alt="Nutrition"
                className="w-full h-80 object-cover"
                style={{ objectPosition: 'center' }}
              />
              {/* Overlay */}
              <div
                className="absolute inset-0 rounded-2xl"
                style={{
                  background:
                    'linear-gradient(135deg, rgba(59,130,246,0.08) 0%, transparent 60%)',
                }}
              />
            </div>

            {/* Floating badge */}
            <div
              className="absolute -bottom-5 -right-5 rounded-xl px-5 py-4 hidden md:block"
              style={{
                background: 'linear-gradient(135deg, #1e3a6e, #1a2d5a)',
                border: '1px solid rgba(59,130,246,0.4)',
                boxShadow: '0 0 30px rgba(59,130,246,0.2)',
              }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="flex items-center justify-center rounded-lg"
                  style={{
                    width: 38,
                    height: 38,
                    background: 'rgba(59,130,246,0.25)',
                  }}
                >
                  <Utensils size={18} color="#3b82f6" />
                </div>
                <div>
                  <div className="text-white font-bold text-sm">
                    {lang === 'de' ? 'Ernährungsplan' : 'Nutrition Plan'}
                  </div>
                  <div className="text-xs" style={{ color: '#64748b' }}>
                    {lang === 'de' ? 'Personalisiert' : 'Personalized'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 md:order-2">
            <p
              className="text-sm font-bold uppercase mb-4"
              style={{ color: '#3b82f6', letterSpacing: '0.2em' }}
            >
              {tx.label}
            </p>

            <h2
              className="font-black leading-tight mb-10"
              style={{
                fontSize: 'clamp(1.6rem, 3.5vw, 2.5rem)',
                color: '#ffffff',
                letterSpacing: '-0.01em',
              }}
            >
              {tx.title}
            </h2>

            <ul className="space-y-5">
              {tx.items.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div
                    className="flex-shrink-0 flex items-center justify-center rounded-full mt-0.5"
                    style={{
                      width: 28,
                      height: 28,
                      background: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
                    }}
                  >
                    <Check size={15} color="#ffffff" strokeWidth={3} />
                  </div>
                  <span
                    className="leading-relaxed font-medium"
                    style={{ color: '#cbd5e1', fontSize: '1.05rem' }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
